<app-search-filter-value-list
  filterName="entityType"
  [keyValues]="aggregation | aggregationKeyValue: pipe.transform"
  (visible)="visible.next($event)"></app-search-filter-value-list>
